import {useAppSelector} from "./store";
import {TransactionsTranslationsState} from "../store/transactionsTranslations";
import {TransactionType} from "../api-client";

type Translation = {
    readonly text: string;
    readonly description: string;
}

export const useTransactionsTranslation = () => {
  const current = useAppSelector<TransactionsTranslationsState>(state => state.transactionsTranslations).transactionsInfo;
  return (type: TransactionType): Translation => {
    const transactionInfo = current.filter((item) => item.type === type)[0];

    if (transactionInfo === undefined) {
      return {text: 'Ошибка', description: 'Ошибка'};
    }

    return {text: transactionInfo.text, description: transactionInfo.description};
  };
};